import { MdClose } from 'react-icons/md';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  dateToStringDDMMYYY,
  dateToStringTime,
} from '../../../../commons/date';

// Rótulos amigáveis para as ações/atores gravados na photo_access_logs.
const ACTION_LABEL = {
  upload: 'Upload',
  download: 'Download',
  zip: 'Download ZIP',
  presign: 'Gerou link',
  view: 'Visualizou',
  thumbnail: 'Miniatura',
  delete: 'Removeu',
};

const ACTOR_LABEL = {
  user: 'Interno',
  client: 'Cliente',
  system: 'Sistema',
};

const PhotoAccessLogsModal = ({ logs }) => (
  <ModalContainer>
    <div className="modal fade" tabIndex="-1" id="modal-photo-access-logs">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title col-11 text-center text-uppercase">
              Auditoria de acesso às fotos
            </h5>
            <MdClose
              id="close"
              size={30}
              data-bs-dismiss="modal"
              type="button"
              onClick={() => {}}
            />
          </div>
          <div className="bg-modal">
            <div className="modal-body">
              {logs.length === 0 ? (
                <p className="text-center m-3">
                  Nenhum acesso registrado para este pedido.
                </p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover text-center table-striped">
                    <thead>
                      <tr>
                        <th scope="col" className="text-start">
                          DATA
                        </th>
                        <th scope="col" className="text-start">
                          HORA
                        </th>
                        <th scope="col" className="text-start">
                          AÇÃO
                        </th>
                        <th scope="col" className="text-start">
                          TIPO
                        </th>
                        <th scope="col" className="text-start">
                          ATOR
                        </th>
                        <th scope="col" className="text-start">
                          USUÁRIO
                        </th>
                        <th scope="col" className="text-start">
                          IP
                        </th>
                        <th scope="col" className="text-start">
                          ARQUIVO
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {logs.map((item) => (
                        <tr key={item.id}>
                          <td className="text-start">
                            {dateToStringDDMMYYY(item.created_at)}
                          </td>
                          <td className="text-start">
                            {dateToStringTime(item.created_at)}
                          </td>
                          <td className="text-start">
                            {ACTION_LABEL[item.action] || item.action}
                          </td>
                          <td className="text-start">{item.photo_type}</td>
                          <td className="text-start">
                            {ACTOR_LABEL[item.actor_type] || item.actor_type}
                          </td>
                          <td className="text-start">
                            {item.user_full_name ||
                              (item.actor_type === 'client'
                                ? 'Cliente (QR)'
                                : '—')}
                          </td>
                          <td className="text-start">{item.ip_address}</td>
                          <td className="text-start">{item.file_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="row justify-content-end">
              <div className="col-6 col-md-2 m-3">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-outline-secondary btn-block col-12"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalContainer>
);

PhotoAccessLogsModal.propTypes = {
  logs: PropTypes.arrayOf(Object).isRequired,
};

export default PhotoAccessLogsModal;

export const ModalContainer = styled.div`
  .bg-modal {
    background-color: #f5f5f5;
    margin: 7px;
  }

  .modal-header {
    border: none;
    background-color: #4f4f4f;
    color: #fff;
    justify-content: center !important;
  }

  .modal-body {
    text-transform: uppercase;
    font-size: 12px;
  }

  svg {
    :hover {
      cursor: pointer;
      color: #ffba00;
    }
  }
`;
